/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomTile.js
 * vim:ft=javascript.jsx:
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import formatCurrency from 'format-currency';
import {
  DEVICES,
  sendGTMEvents,
  setMultipleRoomSelection,
  setMultipleRoomStep,
} from '../../../actions/Booking';
import { addRoomEvent, chooseRoomEvent } from '../../../events/Room';
import { setCoinsApplied, setCoinsEntered, setMaxCoinsToApply } from '../../../actions/Loyalty';
import Select from '../../common/Select';
import PictureSlider from './PictureSlider';
import Quota from './Quota';
import RoomCategory from './RoomCategory';
import RoomBoardTab from './RoomBoardTab';
import RoomAmounts from './RoomAmounts';
import RoomRibbons from './RoomRibbons';
import LoyaltyUserRate from '../../loyalty/LoyaltyUserRate';
import RateSelector from './RateSelector';
import { setOpenReservationDetails } from '../../../actions/Session';

import SeeDetails from '../../ds/molecules/btn/seeDetails';
import Btn from '../../ds/atoms/btn';

import { addSelectedRoomsToCart } from '../../../actions/Cart';
import { getLangValue } from '../../../utils/Generic';
import { getDefaultRoomSelection } from '../../../utils/Room';
import { getMaxCoinsToApply } from '../../../utils';

import '../../../static/less/global/customAnimations.less';
import { FIRST_ORDERED_BOARD_CODES, CALL_CENTER_ROLE } from '../../../constants';
import '../../../static/less/rooms/room-tile.less';
import withNavigate from '../../../withNavigate'; // Importa el HOC

import {
  getTotalAmountsOfSelectedRoomsInUsdOrEur,
  getUpperLimit,
} from '../utils';
import BoardDetailsBlock2 from './BoardDetailsBlock2';

const ratesSort = (a, b) => {
  const attr = a.order === b.order ? 'price_from' : 'order';
  return a[attr] > b[attr] ? 1 : -1;
};

class RoomTile extends React.Component {
  constructor(props) {
    super(props);
    const defaultCombination = getDefaultRoomSelection(
      props.room, props.multipleRoomSelection, props.isMobile, props.isEditingBooking, props.cart.cartHotel);
    /*console.log('defaultCombination:');
    console.log(defaultCombination);*/
    this.state = {
      animateRoom: false,
      selectedBoardCode: defaultCombination.boardCode,
      selectedRateCode: defaultCombination.rateCode,
      availId: defaultCombination.availId,
      mandatoryBoardCode: defaultCombination.isMandatory ? defaultCombination.boardCode : null,
      mandatoryRateCode: defaultCombination.isMandatory ? defaultCombination.rateCode : null,
      rateTooltip: null,
      isSelectedRoom: false, // to identify which of the rooms is being selected
      defaultCombination,
      showFloatingMessage: false,
    };

    this.onRateSelect = this.onRateSelect.bind(this);
    this.onSelectRoom = this.onSelectRoom.bind(this);
    this.onBoardSelect = this.onBoardSelect.bind(this);
    this.onShowRateDetails = this.onShowRateDetails.bind(this);
    this.handleBoardChange = this.handleBoardChange.bind(this);
  }

  sendRoomChooseGA(rateCode, boardCode) {
    const roomEvent = chooseRoomEvent({
      room: this.props.room,
      rateCode,
      boardCode,
      hotel: this.props.hotel,
      lang: this.props.lang,
      utmSource: this.props.utmParams.utm_source,
      lastRequestedInfo: this.props.lastRequestedInfo,
      userCurrency: this.props.currency,
    });
    this.props.dispatch(sendGTMEvents([roomEvent]));
  }

  getAlternativeSelection() {
    // If the second room selection is different to the first one, we want to show a message
    if (this.state.mandatoryBoardCode) {
      const changedBoard = this.state.mandatoryBoardCode !== this.state.selectedBoardCode;
      const changedRate = this.state.mandatoryRateCode !== this.state.selectedRateCode;
      if (changedBoard || changedRate) {
        return { rateCode: this.state.selectedRateCode, boardCode: this.state.selectedBoardCode };
      }
    }
    return null;
  }

  getCombiningBoardCodes() {
    if (!this.props.combiningData) {
      // There is no need to combine boards in 1 room mode
      return null;
    }
    // We want to check which boards combine with the currently selected rate
    const rate = this.props.room.rates.find((r) => r.code === this.state.selectedRateCode);
    const rateCombinations = this.props.combiningData[rate.code];

    // But if the rate is not valid for the selected, we return empty so that the rate has to change
    if (!rateCombinations) {
      return [];
    }
    return rateCombinations.validBoardCodes;
  }

  onRateSelect(rate) {
    this.setState({ selectedRateCode: rate.code });
    this.sendRoomChooseGA(rate.code, this.state.selectedBoardCode);
  }

  onBoardSelect(room, board) {
    const selectedRate = this.getSelectedRate(room, board.code);
    this.setState({ selectedBoardCode: board.code, availId: board.avail_id, selectedRateCode: selectedRate });
    this.sendRoomChooseGA(selectedRate, board.code);
  }

  onShowRateDetails(rate) {
    this.setState({ rateTooltip: rate ? rate.code : null });
  }

  ApplyMaxCoinsToFinalRoomsAmount = () => {
    //const roomData = this.props.multipleRoomSelection;
    //let rateCodePrimeroSeleccionado = null;
    //let boardCodePrimeroSeleccionado = null;
    // Iterar sobre las claves numéricas y encontrar el primer cuarto seleccionado
    //const foundKey = Object.keys(roomData).find(k => roomData[k] && roomData[k].rateCode);
    /*if (foundKey !== undefined) {
      rateCodePrimeroSeleccionado = roomData[foundKey].rateCode;
      boardCodePrimeroSeleccionado = roomData[foundKey].boardCode;
    }*/
    // Salía no used vars

    //meter esto dentro de select-room-button

    // Si es agentCode y agentSell false y no quiso usar coins seteamos los coins usados en cero
    if (this.props.agentUseCoins === 'false') {
      this.props.dispatch(
        setCoinsEntered(0));
      this.props.dispatch(
        setCoinsApplied(0));
      this.props.dispatch(
        setMaxCoinsToApply(0));
      return;
    }

    const totalAmounts = getTotalAmountsOfSelectedRoomsInUsdOrEur(this.props);

    if (this.props.isLoyaltyUserLoggedIn) {
      if (this.props.new_member === true && this.props.new_member_discount_percentage_activated === true
          && this.props.memberInfo && this.props.multipleRoomSelection['1'] != null) {
        const value = getUpperLimit(this.props);
        if (value > 0) {
          this.props.dispatch(
            setCoinsEntered(value));
          this.props.dispatch(
            setCoinsApplied(value));
          this.props.dispatch(
            setMaxCoinsToApply(value));
        }
      } else if (totalAmounts.totalAmount > 0) {
        const value = getMaxCoinsToApply(totalAmounts.totalAmount, false);
        if (value > 0) {
          this.props.dispatch(
            setCoinsEntered(value));
          this.props.dispatch(
            setCoinsApplied(value));
          this.props.dispatch(
            setMaxCoinsToApply(value));
        }
      }
    }
  };

  async onSelectRoom(room, multipleRoomStepFromParent = this.props.multipleRoomStep, selectedRateFromParent = null) {
    const rates = this.getRateOptions(room);
    this.setState({ isSelectedRoom: true, showFloatingMessage: true });
    // Create a function that returns a Promise for the timeout
    // eslint-disable-next-line no-promise-executor-return
    const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    // Wait another 2 seconds before hiding the floating message
    // Oculta el mensaje flotante después de 2 segundos
    await timeout(1000);
    this.setState({ showFloatingMessage: false, isSelectedRoom: false });

    // We register the GA event
    const roomEvent = addRoomEvent({
      hotel: this.props.hotel,
      room,
      userCurrency: this.props.currency,
      nights: this.props.lastRequestedInfo.nights,
      lang: this.props.lang,
    });
    this.props.dispatch(sendGTMEvents([roomEvent]));

    // Then we add to room directly if this search is for only 1 room
    /*
    //Decidimos quitar esta parte para que no te mande a la página de confirmación automáticamente cuando sólo hay
    //un cuarto, porque sino ya no se ve cómo se agrega al carrito, mejor que al darle click en book now que te lleve
    //a la página de confirmación
    if (this.props.distributions.length === 1) {
      this.addRoomToCart(room);
      const selectedRate = room.rates.find(rate => rate.code === this.state.selectedRateCode);
      const selectedBoard = selectedRate.boards.find(board => board.code === this.state.selectedBoardCode);
      //alert(getMaxCoinsToApply(selectedBoard.amount[this.props.hotel.default_currency].amount, true));
      //TODO
      // console.log('this.props.hotel.default_currency:');
      // console.log(this.props.hotel.default_currency);
      // console.log('selectedBoard.amount[this.props.hotel.default_currency].amount:');
      // console.log(selectedBoard.amount[this.props.hotel.default_currency].amount);
      this.props.dispatch(
        //setCoinsEntered(getMaxCoinsToApply(selectedBoard.amount[this.props.hotel.default_currency].amount, true)));
        setCoinsEntered(getMaxCoinsToApply(selectedBoard.amount.USD.amount, false)));
      //Actualmente hay un error en producción
      //hay un error, cuando se está en el confirmation form y está logeado con loyalty
      //tiene ciertos coins, luego da atrás y vuelve a elegir la misma opción
      //al revisar lo que debe pagar es una cantidad negativa
      //ese error pasa sólo con mi usuario que tiene demasiadas coins, no con todos
      //Se corrige siempre pasando el costo en dólares (Preguntar si es correcto eso)

      this.props.dispatch(
        //setCoinsApplied(getMaxCoinsToApply(selectedBoard.amount[this.props.hotel.default_currency].amount, true)));
        setCoinsApplied(getMaxCoinsToApply(selectedBoard.amount.USD.amount, false)));
      //Actualmente hay un error en producción
      //hay un error, cuando se está en el confirmation form y está logeado con loyalty
      //tiene ciertos coins, luego da atrás y vuelve a elegir la misma opción
      //al revisar lo que debe pagar es una cantidad negativa
      //ese error pasa sólo con mi usuario que tiene demasiadas coins, no con todos
      //Se corrige siempre pasando el costo en dólares (Preguntar si es correcto eso)
      return;
    }
    */
    // If this is the second room, we select the same information as for the first room.
    // Additionally, we will keep the "alternativeSelection" to let them choose between the two combinations
    /*console.log('this.state.mandatoryRateCode:');
    console.log(this.state.mandatoryRateCode);
    console.log('this.state.selectedRateCode:');
    console.log(this.state.selectedRateCode);*/
    const roomSelection = {
      roomId: multipleRoomStepFromParent,
      room,
      rateCode: (this.props.isEditingBooking && selectedRateFromParent)
        ? rates.find((rate) => rate.code === selectedRateFromParent.code).code : this.state.mandatoryRateCode
      || this.state.selectedRateCode,
      boardCode: this.state.mandatoryBoardCode || this.state.selectedBoardCode,
      availId: this.state.availId,
      use: room.use_requested, // Revisar eso
      alternativeSelection: this.getAlternativeSelection(),
    };
    /*console.log('tema:');
    console.log('roomSelection:');
    console.log(roomSelection);*/
    this.props.dispatch(setMultipleRoomSelection(roomSelection));

    if (this.props.isEditingBooking === true) {
      // Si estamos editando la booking, el nuevo multipleRoomStep debe ser el siguiente cuarto que esté en null en multipleRoomSelection,
      //no el siguiente cuarto, porque eso seleccionaría el siguiente cuarto que puede estar lleno, entonces no queremos eso, sino que se
      //posicione en el siguiente cuarto faltante
      /*console.log('snapshot:');
      console.log(this.props.multipleRoomSelection);*/
      let array = ['1', '2', '3', '4'];
      //console.log('multipleRoomStepFromParent:');
      //console.log(multipleRoomStepFromParent);
      array = array.filter((item) => (item > multipleRoomStepFromParent && item !== multipleRoomStepFromParent));
      // Con eso hacemos que seleccione el siguiente cuarto que está vacío
      const firstValidRoomKey = array.find((key) => this.props.multipleRoomSelection[key] === null);
      const numberFirstValidRoomKey = Number(firstValidRoomKey);
      //console.log('numberFirstValidRoomKey:');
      //console.log(numberFirstValidRoomKey);
      /*console.log('TEMA:');
      console.log('seteando firstValidRoomKey:');
      console.log(firstValidRoomKey);*/
      if (numberFirstValidRoomKey <= this.props.distributions.length) {
        this.props.dispatch(setMultipleRoomStep(firstValidRoomKey));
      }
    } else {
      const nextRoomToBeSelected = Number(multipleRoomStepFromParent) + 1;
      if (nextRoomToBeSelected <= this.props.distributions.length) {
        this.props.dispatch(setMultipleRoomStep(nextRoomToBeSelected.toString()));
      }
      if (nextRoomToBeSelected === this.props.distributions.length + 1) {
        if (this.props.isMobile) {
          this.props.dispatch(setOpenReservationDetails(true));
        } else {
          this.scrollDownToNewShoppingCart();
        }
      }
    }
    // this.ApplyMaxCoinsToFinalRoomsAmount(); //Se tuvo que mandar a llamar
    // desde el componentDidUpdate ya que cuando se llamaba, this.props.multipleRoomSelection['1']
    // todavía era null. Y en el componentDidUpdate nos aseguramos de llamarlo cuando cambia
    // this.props.multipleRoomSelection y cuando this.props.multipleRoomSelection['1'] tiene valor
  }

  componentDidUpdate(prevProps) {
    // Check if multipleRoomSelection has been updated
    if (prevProps.multipleRoomSelection !== this.props.multipleRoomSelection && this.props.multipleRoomSelection['1']) {
      this.ApplyMaxCoinsToFinalRoomsAmount();
    }

    // Lo siguiente es un fix necesario para el escenario de editar reserva con una sóla habitación.
    // Cuando son varias habitaciones no hay problema porque cada vez que se elije un cuarto se hace setMultipleRoomSelection, lo cual
    // obliga a renderizar todo el componente y llega bien el rate seleccionado previamente
    // El problema sólo es cuando es un sólo cuarto porque en onSelectRoom, no se manda a llamar a setMultipleRoomSelection puesto
    // que el multipleRoomStep no puede ser mayor al props.distributions.length
    if (prevProps.multipleRoomSelection !== this.props.multipleRoomSelection && this.props.isEditingBooking) {
      const rateOptions = this.getRateOptions(this.props.room);
      if (rateOptions.length === 1) {
        //console.log('llamando a click en rate');
        this.onRateSelect(rateOptions[0]);
      }
    }
  }

  componentDidMount() {
    if (this.props.registerCallbacks) {
      this.props.registerCallbacks({
        onRateSelect: this.onRateSelect,
        onSelectRoom: this.onSelectRoom,
        onBoardSelect: this.onBoardSelect,
      });
    }
  }

  scrollDownToNewShoppingCart() {
    // Con la actualización de react hacia el scroll sin esperar a que cargara el contenido, por eso agregamos ese pequeño timeout
    setTimeout(() => {
      const reservationContainer = document.querySelector('.reservation-container');
      if (reservationContainer) {
        reservationContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 50); // El tiempo en milisegundos puede variar dependiendo de la carga del contenido
  }

  addRoomToCart(room) {
    const roomSelection = {
      roomId: '1',
      roomCode: room.code,
      rateCode: this.state.selectedRateCode,
      boardCode: this.state.selectedBoardCode,
      availId: this.state.availId,
      use: room.use_requested,
    };
    this.setState({ isSelectedRoom: true });
    this.props.dispatch(addSelectedRoomsToCart([roomSelection], this.props.navigate));
  }

  getRoomName(room) {
    const roomName = getLangValue(room, this.props.lang, 'name');
    return roomName.toLowerCase();
  }

  getBoardData(room, boardCode) {
    for (let i = 0; i < room.rates.length; i++) {
      const rate = room.rates[i];
      const board = rate.boards.find((boardObj) => boardObj.code === boardCode);
      if (board) {
        return board;
      }
    }
    return { code: boardCode, name: boardCode };
  }

  getBoardPrices(room, currencyCode, selectedRate) {
    // We need to obtain the minimumPrice for each board, for any rate
    const boardAmounts = {};
    const combiningBoardCodes = this.getCombiningBoardCodes();
    selectedRate.boards.forEach((board) => {
      // We need to make sure we only check the rate / boards which are combinable (for TwoRoom mode)
      if (combiningBoardCodes === null || combiningBoardCodes.indexOf(board.code) !== -1) {
        const minBoardAmount = boardAmounts[board.code] ? boardAmounts[board.code].amount : 100000000;
        if (minBoardAmount > board.amount[currencyCode].amount) {
          boardAmounts[board.code] = board.amount[currencyCode];
        }
      }
    });
    return boardAmounts;
  }

  getFormattedAmountNight(currency, amount) {
    if (!amount) {
      return null;
    }
    const nightlyAmount = amount / this.props.lastRequestedInfo.nights;
    const roundCurrency = { ...currency, minimumFractionDigits: 0, maximumFractionDigits: 0 };
    return formatCurrency(nightlyAmount, roundCurrency);
  }

  getRateFormattedText(rate) {
    const baseText = getLangValue(rate, this.props.lang, 'cancellation_txt') || '';
    return baseText.replace(/\r\n/g, '<br/>');
  }

  getRateOptions(room) {
    // We only need the rates from the selectedBoard.
    let selectedBoardRates = room.rates.filter((r) => r.boards.find((b) => b.code === this.state.selectedBoardCode));
    const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => this.props.multipleRoomSelection[key] !== null);
    /*console.log('this.props.multipleRoomSelection[Number(firstValidRoomKey)]:');
    console.log(this.props.multipleRoomSelection[Number(firstValidRoomKey)]);*/
    if (this.props.multipleRoomSelection && this.props.multipleRoomSelection[Number(firstValidRoomKey)]) {
      selectedBoardRates = selectedBoardRates.filter((rate) =>
        rate.code === this.props.multipleRoomSelection[Number(firstValidRoomKey)].rateCode);
    }
    /*console.log('selectedBoardRates:');
    console.log(selectedBoardRates);*/
    const sortedRates = selectedBoardRates.map((rate) => ({
      code: rate.code,
      name: getLangValue(rate, this.props.lang, 'name'),
      cancellation_txt: this.getRateFormattedText(rate),
      order: rate.order, // field needed to be able to sort the rates
      price_from: rate.price_from,
    })).sort(ratesSort);
    // If there is combiningData, we filter out those rates that are cannot combine with other room rates
    if (this.props.combiningData) {
      return sortedRates.filter((rate) => this.props.combiningData[rate.code]);
    }
    return sortedRates;
  }

  getSelectedRate(room, boardCode = this.state.selectedBoardCode) {
    const currentBoardRates = room.rates.filter((r) => r.boards.find((b) => b.code === boardCode));
    const rate = currentBoardRates.find((r) => r.code === this.state.selectedRateCode);
    return rate ? rate.code : this.state.defaultCombination.rateCode;
  }

  renderSelectedAmounts(hotel, room, selectedBoard) {
    const { currency } = this.props;
    return (
      <RoomAmounts
        amounts={selectedBoard.amount}
        currency={currency}
        showOriginal={hotel.show_original_price}
        nights={this.props.lastRequestedInfo.nights}
        roundAmount
        showDescription={true}
        showFinalAmount={false}
        coinsApplied={this.props.coinsApplied}
      />
    );
  }

  renderBoardSelect(room, selectedRate) {
    const { currency, lang, isMobile } = this.props;
    const minBoardAmounts = this.getBoardPrices(room, currency.code, selectedRate);

    let orderedBoardCodes = Object.keys(minBoardAmounts);
    const firstOrderedBoards = FIRST_ORDERED_BOARD_CODES.filter((boardKey) => orderedBoardCodes.includes(boardKey));

    if (isMobile) {
      firstOrderedBoards.concat(
        orderedBoardCodes
          .filter((boardCode) => !firstOrderedBoards.includes(boardCode))
          .sort(
            (boardCodeA, boardCodeB) => minBoardAmounts[boardCodeA].amount - minBoardAmounts[boardCodeB].amount,
          ),
      );
    }

    if (this.props.multipleRoomSelection && this.props.multipleRoomSelection[1]) {
      orderedBoardCodes = orderedBoardCodes.filter((boardKey) =>
        boardKey === this.props.multipleRoomSelection[1].boardCode);
    }
    let pricePerNightToShow = minBoardAmounts[this.state.selectedBoardCode].amount;
    if (this.props.hotel != null) {
      if (this.props.hotel.percentage_total_taxes > 0) {
        pricePerNightToShow -= (pricePerNightToShow * (this.props.hotel.percentage_total_taxes / 100));
      }
    }
    return (
      <Fragment>
        <select
          className="board-select"
          value={this.state.selectedBoardCode}
          onChange={this.handleBoardChange}
        >
          {orderedBoardCodes.map((boardCode) => (
            <option key={`board_${room.code}_${boardCode}`} value={boardCode}>
              {/*{this.getBoardData(room, boardCode).name} -
                {this.getFormattedAmountNight(currency, minBoardAmounts[boardCode].amount)}{*/}
              {getLangValue(this.getBoardData(room, boardCode), lang, 'name')}
            </option>
          ))}
        </select>
        <div className='selected-board-resume'>
          <span>{this.context.t('From')} {this.getFormattedAmountNight(currency, pricePerNightToShow)} {this.context.t('per night')}</span>
        </div>
      </Fragment>
    );
  }

  handleBoardChange(event) {
    const selectedBoardCode = event.target.value;
    this.onBoardSelect(this.props.room, { code: selectedBoardCode, avail_id: this.state.availId });
  }

  renderBoardTabs(room, selectedRate) {
    const { currency, lang, isMobile } = this.props;
    const minBoardAmounts = this.getBoardPrices(room, currency.code, selectedRate);
    let orderedBoardCodes = Object.keys(minBoardAmounts);
    const firstOrderedBoards = FIRST_ORDERED_BOARD_CODES.filter((boardKey) => orderedBoardCodes.includes(boardKey));
    if (isMobile) {
      firstOrderedBoards.concat(
        orderedBoardCodes
          .filter(
            ((boardCode) => !firstOrderedBoards.includes(boardCode)),
          )
          .sort(
            (boardCodeA, boardCodeB) => minBoardAmounts[boardCodeA].amount + minBoardAmounts[boardCodeB].amount,
          ),
      );
    }
    if (this.props.multipleRoomSelection && this.props.multipleRoomSelection[1]) {
      orderedBoardCodes = orderedBoardCodes.filter((boardKey) =>
        boardKey === this.props.multipleRoomSelection[1].boardCode);
    }
    return (
      <ul className="board-list">
        {
          orderedBoardCodes
            .map((boardCode) => (
              <RoomBoardTab key={`board_${room.code}_${boardCode}`} lang={lang} isMobile={isMobile}
                board={this.getBoardData(room, boardCode)}
                onBoardSelect={(board) => this.onBoardSelect(room, board)}
                amountStr={this.getFormattedAmountNight(currency, minBoardAmounts[boardCode].amount)}
                isSelected={this.state.selectedBoardCode === boardCode}
              />
            ))
        }
      </ul>
    );
  }

  renderRateSelector(room) {
    const { isMobile } = this.props;
    const selectedRate = this.getSelectedRate(room);
    return (
      <Select
        selectId={`rates_${room.code}`} onSelect={this.onRateSelect}
        options={this.getRateOptions(room)} selectedValue={{ code: selectedRate }}
        lang={this.props.lang} detailsField="cancellation_txt" isMobile={isMobile}
        liClass='fontRatesMobile' />
    );
  }

  renderRoomInfo(room) {
    const { onShowRoomDetails } = this.props;
    if (this.props.device === DEVICES.MOBILE) {
      const {
        hotel, currency, lastRequestedInfo,
      } = this.props;
      const selectedRate = room.rates.find((rate) => rate.code === this.state.selectedRateCode);
      // if the room doesn't have selectedRateCode
      if (!selectedRate) {
        return null;
      }
      const selectedBoard = selectedRate.boards.find((board) => board.code === this.state.selectedBoardCode);
      return (
        <div className="row">
          <div className="custom60Width">
            <div className="room-info">
              <div className="room-info__title text-capitalize"
                onClick={() => onShowRoomDetails(room, 'description')}>
                {this.getRoomName(room)}
              </div>
              <RoomCategory category={room.category} />
              <div className="flex flex-wrap -mx-2 mt-1">
                <SeeDetails className="mx-1 seeDetailsTextMobile"
                  onClick={() => onShowRoomDetails(room, 'description')}/>
                {room.url_360 && <Btn
                  icon="view360"
                  className="mx-1 text-primary"
                  onClick={() => onShowRoomDetails(room, 'room-360')}>
                    {this.context.t('Room 360º')}
                </Btn>}
                {(room.floor_plan && room.floor_plan.length > 0) && <Btn
                  icon="file"
                  className="mx-1 text-primary"
                  onClick={() => onShowRoomDetails(room, 'floor-plan')}>
                    {this.context.t('Room Floor Plan')}
                </Btn>}
                {room.url_youtube && <Btn
                  icon="video"
                  className="mx-1 text-primary"
                  onClick={() => onShowRoomDetails(room, 'room-video')}>
                    {this.context.t('Room video')}
                </Btn>}
              </div>
              {/*Pidieron que se quitara esta parte donde se mostraba ejemplo: From $10,892 MXN per night
              y pidieron que se quitara el selector de boards*/}
              {/*this.renderBoardSelect(room, selectedRate)*/}
              <Quota quota={room.quota} chain={this.props.chain} />
            </div>
          </div>
          <div className="custom40Width">
            <span className={`totalPriceText ${this.props.hotel.show_original_price ? '' : 'mb-3'}`}>{this.context.t('Total Price')}</span>
            {(this.props.isLoyaltyUserLoggedIn === false && this.props.selectedStatus !== 'becomeMember')
            && <div>
              <div className="card_amount">
                <RoomAmounts
                  amounts={selectedBoard.amount}
                  currency={currency}
                  showOriginal={hotel.show_original_price}
                  nights={lastRequestedInfo.nights}
                  extraClass={`flex ${currency.code === 'MXN' ? 'MXN' : ''} ${currency.code === 'USD' ? 'USD' : ''}`}
                  showDescription={false}
                  showFinalAmount={false}
                  coinsApplied={this.props.coinsApplied}
                  showAmounts={'TOTAL'}
                  roundAmount={this.props.device === DEVICES.MOBILE}
                />
              </div>
              {this.renderSelectButton(room)}
            </div>
            }
            {
                (this.props.isLoyaltyUserLoggedIn || this.props.selectedStatus === 'becomeMember')
              && <div>
                <div className="card_amount">
                      <Fragment>
                        <RoomAmounts
                          amounts={selectedBoard.amount}
                          currency={currency}
                          showOriginal={hotel.show_original_price} // Acá debemos mostrar sólo la cantidad original con forceCross=true
                          nights={lastRequestedInfo.nights}
                          extraClass={`flex ${currency.code === 'MXN'
                            ? 'MXN' : ''} ${currency.code === 'USD' ? 'USD' : ''}`}
                          showDescription={false}
                          showFinalAmount={false}
                          coinsApplied={this.props.coinsApplied}
                          showAmounts={'TOTAL'}
                          roundAmount={this.props.device === DEVICES.MOBILE}
                          forceCrossedAmount={true}
                          doNotShowCurrent={hotel.show_original_price}
                        />
                        {this.renderLoyaltyUserRate(selectedBoard)}
                      </Fragment>
                </div>
                {this.renderSelectButton(room)}
              </div>
            }
          </div>
        </div>
      );
    }

    return (
      <div className="room-info">
        <div className="room-info__title text-capitalize"
          onClick={() => onShowRoomDetails(room, 'description')}>
          {this.getRoomName(room)}
        </div>
        <RoomCategory category={room.category} />
        <div className="flex flex-wrap -mx-2 mt-1">
          <SeeDetails className="mx-1 seeDetailsText" onClick={() => onShowRoomDetails(room, 'description')}/>
          {room.url_360 && <Btn
            icon="view360"
            className="mx-1 text-primary"
            onClick={() => onShowRoomDetails(room, 'room-360')}>
              {this.context.t('Room 360º')}
          </Btn>}
          {(room.floor_plan && room.floor_plan.length > 0) && <Btn
            icon="file"
            className="mx-1 text-primary"
            onClick={() => onShowRoomDetails(room, 'floor-plan')}>
              {this.context.t('Room Floor Plan')}
          </Btn>}
          {room.url_youtube && <Btn
            icon="video"
            className="mx-1 text-primary"
            onClick={() => onShowRoomDetails(room, 'room-video')}>
              {this.context.t('Room video')}
          </Btn>}
        </div>
      </div>
    );
  }

  renderSelectButton(room) {
    const { isSelectedRoom, showFloatingMessage } = this.state;
    const { isCartUpdating } = this.props;

    const buttonClass = isCartUpdating && isSelectedRoom ? ' adding' : '';
    return (
      <div className="select-room-container">
        <button className={`select-room-button${buttonClass}`}
                onClick={() => this.onSelectRoom(room)} disabled={isCartUpdating || isSelectedRoom}>
          { isSelectedRoom ? this.context.t('Added ✔') : this.context.t('Select')}
        </button>
        {showFloatingMessage && (
          <div className="floating-message">
            <span className="checkmark">✔</span> {this.context.t('Selected')}
          </div>
        )}
      </div>
    );
  }

  renderLoyaltyUserRate(selectedBoard) {
    if (this.props.memberInfo != null) {
      return (
        <LoyaltyUserRate
          board={selectedBoard}
          showJoinLoyaltyMessage={true}
          showJustTotalQuantity={true}
        />
      );
    }
    return null;
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  render() {
    const {
      hotel, room, chain, isMobile, device, currency, lastRequestedInfo,
    } = this.props;

    const selectedRate = room.rates.find((rate) => rate.code === this.state.selectedRateCode);
    // if the room doesn't have selectedRateCode
    if (!selectedRate) {
      return null;
    }
    const selectedBoard = selectedRate.boards.find((board) => board.code === this.state.selectedBoardCode);
    let pricesInfoClassToUse = '';
    if (device === DEVICES.MOBILE) {
      pricesInfoClassToUse = 'pricesInfoMobile';
    }

    return (
      <CSSTransition
        in={this.state.animateRoom}
        timeout={500}
        classNames={{ enter: 'heartbeat room-tile' }}
        style={this.props.isEditingBooking === true && room.quota === 0 ? { display: 'none' } : {}}
        onExited={() => this.setState({ animateRoom: false })}
        key={room.code}>
        {/* eslint-disable-next-line react/no-string-refs */}
        <div ref="Room" className="room-card">
          <RoomRibbons hotel={hotel} room={room} selectedBoard={selectedBoard}
            loyalty_name={this.props.chainData.loyalty_name}
            new_member_discount_percentage={this.getNewMemberDiscountPercentage()}
            new_member_discount_percentage_activated = {this.props.new_member_discount_percentage_activated}
            new_member = {this.props.new_member}
            membershipName = {((this.props.isLoyaltyUserLoggedIn || this.props.selectedStatus === 'becomeMember')
              && (this.props.new_member_discount_percentage_activated && this.props.new_member))
              ? this.props.memberInfo.membershipName.toUpperCase() : ''}
            agentCode = {this.props.agentCode}
            agentSell = {this.props.agentSell}
          />
          {(device === DEVICES.DESKTOP || device === DEVICES.TABLETH || device === DEVICES.TABLETV)
          && <div className='row'>
            <div className='col-xs-12 col-md-9'>
              <PictureSlider photos={room.photos} imageSize="sm" isMobile={isMobile}
                          onPictureClicked={() => this.props.onShowRoomDetails(room, 'gallery')} />
            </div>
            <div className='col-xs-12 col-md-3 removeSpaceMd3'>
              <div className={`room-card__first ${device === DEVICES.TABLETH ? 'tabletHMarginLeft20' : ''}`}>
                {this.renderRoomInfo(room)}
                {/*Pidieron que se quitara esta parte donde se mostraba ejemplo: From $10,892 MXN per night
                y pidieron que se quitara el selector de boards*/}
                {/*this.renderBoardSelect(room, selectedRate)*/}
                <Quota quota={room.quota} chain={chain} />
                <div>
                  {this.renderSelectButton(room)}
                </div>
              </div>
            </div>
          </div>}
          {(device === DEVICES.MOBILE)
          && <Fragment>
            <PictureSlider photos={room.photos} imageSize="sm" isMobile={isMobile}
                          onPictureClicked={() => this.props.onShowRoomDetails(room, 'gallery')} />
            <div className="room-card__first">
              {this.renderRoomInfo(room)}
            </div>
          </Fragment>}

          <div className={`${this.props.device === DEVICES.MOBILE
            ? 'room-card__content_mobile' : 'room-card__content'}`}>
              <div className="card-content mt-auto room-card__select mb-2 w-100">
                <div className={`prices-info ${pricesInfoClassToUse}`}>
                  <p className="select-your-rate">{this.context.t('Select your rate')}</p>
                  <p className="per-night">{this.context.t('per night')}</p>
                  { device !== DEVICES.MOBILE
                  && <p className="total">{this.context.t('total price')}</p>
                  }
                </div>
                <RateSelector
                  hotel={hotel}
                  options={this.getRateOptions(room)}
                  lang={this.props.lang}
                  detailsField="cancellation_txt"
                  currency={currency}
                  selectId={`rates_${room.code}`}
                  onSelect={this.onRateSelect}
                  selectedValue={{
                    code: this.getRateOptions(room).length === 1
                      ? this.getRateOptions(room)[0].code : this.getSelectedRate(room),
                  }}
                  selectedBoard={selectedBoard}
                  lastRequestedInfo={lastRequestedInfo}
                  coinsApplied={this.props.coinsApplied}
                />
                <BoardDetailsBlock2/>
              </div>
          </div>

        </div>
      </CSSTransition>
    );
  }
}

RoomTile.propTypes = {
  room: PropTypes.object.isRequired,
  hotel: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
  onShowRoomDetails: PropTypes.func,
  combiningData: PropTypes.object, // Indicates which Rate / Boards are available (for TwoRoom mode)
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

RoomTile.defaultProps = {
  onShowRoomDetails: () => null,
};

RoomTile.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  isMobile: state.booking.device === DEVICES.MOBILE,
  device: state.booking.device,
  isCartUpdating: state.cart.isUpdating,
  lang: state.i18nState.lang,
  currency: state.booking.filterCurrency,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  multipleRoomStep: state.booking.multipleRoomStep,
  lastRequestedInfo: state.booking.last_requested_info,
  chain: state.bookingFormState.chain,
  distributions: state.bookingFormState.distributions,
  utmParams: state.bookingFormState.utmParams || {},
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  chainData: state.session.chainData,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  conversionRates: state.loyalty.conversionRates,
  coinsApplied: state.loyalty.coinsApplied,
  coinsEntered: state.loyalty.coinsEntered,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  cart: state.cart,
  mostrarExtras: false,
  openReservationDetails: state.session.openReservationDetails,
  isEditingBooking: state.booking.isEditingBooking,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  agentUseCoins: state.booking.agentUseCoins,
});

const ConnectedRoomTile = connect(mapStateToProps)(RoomTile);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedRoomTile);
